import * as angular from 'angular';
import * as moment from 'moment';

import { ComponentDefinition, KeyValuePair } from '../../models';
import { momentFormat } from '../../common';
import { TextWidget } from './text.widget';

class TextController implements angular.IComponentController {
    isLoading: boolean;
    loadingMessage: string;
    item: TextWidget;
    text: string;

    static $inject = ['$scope'];

    constructor(private $scope: angular.IScope) {
    }

    $onInit() {
        this.$scope.$watch(() => this.item, () => this.refresh(), true);
        this.refresh();
    }


    private refresh() {
        let text = this.item.configuration.text;

        if (this.item.data && this.item.data.length > 0) {

            const copy = angular.copy(this.item.data);
            this.formatDates(copy);

            copy.forEach(v => {
                if (text.indexOf(v.key) >= 0) {
                    text = text.split(v.key).join(v.value);
                }
            });
        }
        this.text = text;
    }

    private formatDates(variables: KeyValuePair<string, string>[]): void {
        const format = this.item.configuration.dateFormat
            ? this.item.configuration.dateFormat
            : momentFormat;

        variables.forEach(kv => {
            if (kv.key.toLowerCase().indexOf('date') >= 0) {
                try {
                    const d = moment(kv.value, moment.ISO_8601);
                    if (d.isValid()) {
                        kv.value = d.format(format);
                    }
                } catch (e) {
                    // silently pass to next value
                }
            }
        });
    }
}

export const wtText: ComponentDefinition = {
    componentId: 'wtText',
    controller: TextController,
    template: require('./text.component.html'),
    controllerAs: 'vm',
    bindings: {
        item: '='
    }
};